<div [formGroup]="formGroup">
  <!-- region Marketing Consents -->
  <div class="wt-margin-top-4 wt-margin-bottom-4  sb-form-block__text sb-form-block__text grey-line-block">
    <h1 class="sb-form-block__title">{{ 'ENTITY.CONSENTS.NO_MISSING' | translate }}</h1>
  </div>
  <!--OLD CODE <div class="wt-margin-top-4 wt-margin-bottom-2 wt-text-light-m sb-color-grey-dark sb-form-block__text grey-line-block"
       OLD CODE [innerHTML]="'ENTITY.CONSENTS.PRIVACY-INFO' | translate">
  OLD CODE </div>-->
  <div class="sb-form-block__fields">
    <div class="wt-margin-top-4 data-treatment-container">
      <div class="wt-text-light-m" [innerHTML]="'ENTITY.CONSENTS.DATA-TREATMENT-ACCEPTED' | translate" *ngIf="!shouldShowAllConsents"></div>
      <div class="wt-text-light-m" [innerHTML]="'ENTITY.CONSENTS.DATA-TREATMENT-ACCEPTED-OPEN' | translate" *ngIf="shouldShowAllConsents"></div>
      <div class="toggle-consents" *ngIf="!shouldShowAllConsents">
        <a class="wt-link wt-text-base-m" (click)="onConsentClick($event)">
          {{(shouldShowAllConsents ? 'ENTITY.CONSENTS.HIDE-ALL' : 'ENTITY.CONSENTS.SHOW-ALL') | translate}}
        </a>
        <img src="assets/images/consent-edit.svg" alt="Mostra consensi" class="show-consents" *ngIf="(!shouldShowAllConsents)">
      </div>
    </div>
  </div>
  <div class="sb-form-block__fields wt-margin-top-5" formGroupName="marketingConsents" *ngIf="shouldShowAllConsents">
    <div class="col-xs-12 wt-margin-bottom-2" *ngFor="let consent of formGroup.get('marketingConsents')['controls'] | inferObjectKeys">
      <wt-input-checkbox [formControlName]="consent">
        <div class="wt-text-light-m" [innerHTML]="consent | inferConsentText | translate"></div>
      </wt-input-checkbox>
    </div>
  </div>
</div>
<!-- endregion -->
